import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var MoonStar = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "moon-star",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m18 2 .6178 1.2356c.2655.531.3982.7965.5756 1.0265.1573.2042.3403.3872.5445.5445.23.1774.4955.3101 1.0265.5756L22 6l-1.2356.6178c-.531.2655-.7965.3982-1.0265.5756a2.9964 2.9964 0 0 0-.5445.5445c-.1774.23-.3101.4955-.5756 1.0265L18 10l-.6178-1.2356c-.2655-.531-.3982-.7965-.5756-1.0265a2.9964 2.9964 0 0 0-.5445-.5445c-.23-.1774-.4955-.3101-1.0265-.5756L14 6l1.2356-.6178c.531-.2655.7965-.3982 1.0265-.5756a2.9964 2.9964 0 0 0 .5445-.5445c.1774-.23.3101-.4955.5756-1.0265L18 2Zm3 11.3893c-1.311 2.2997-3.7855 3.8502-6.6221 3.8502-4.2068 0-7.6172-3.4103-7.6172-7.6172 0-2.8368 1.5508-5.3114 3.8508-6.6223C5.7798 3.4581 2 7.527 2 12.4785 2 17.7371 6.263 22 11.5215 22c4.9514 0 9.02-3.7794 9.4785-8.6107Z"
    })
  }));
};
export default MoonStar;